import React, { useEffect, useState } from "react";
import {
  FaGamepad,
  FaDatabase,
  FaNewspaper,
  // FaUserTie,
  // FaBalanceScale,
  // FaStethoscope,
  // FaAppleAlt,
  FaEdit,
  FaBullhorn,
  // FaStore,
  FaTimes,
  FaSignOutAlt,
  FaUniversity,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AiFillBulb } from "react-icons/ai";
import { useAuth } from "../context/AuthContext";

const DsportAdminDashboard = () => {
  const navigate = useNavigate();
  const [accessRights, setAccessRights] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [showNewsModal, setShowNewsModal] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    // Pull access rights from context user if admin
    if (user?.isAdmin) {
      setAccessRights(user.accessRights || {});
    }
    setIsLoading(false);
  }, [user]);

  // Define all admin modules with their properties
  const adminModules = [
    {
      id: "arenaControls",
      icon: (
        <FaGamepad className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
      ),
      text: "Arena Controls",
      route: "/AdminDashboard",
      moduleKey: "arena",
    },
    // {
    //   id: "coachControls",
    //   icon: (
    //     <FaUserTie className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
    //   ),
    //   text: "Coach Controls",
    //   route: "/coach-admin",
    //   moduleKey: "coach",
    // },
    // {
    //   id: "refereeControls",
    //   icon: (
    //     <FaBalanceScale className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
    //   ),
    //   text: "Refree Controls",
    //   route: "/referee-admin",
    //   moduleKey: "refree",
    // },
    // {
    //   id: "physicianControls",
    //   icon: (
    //     <FaStethoscope className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
    //   ),
    //   text: "Physician Controls",
    //   route: "/physician-admin",
    //   moduleKey: "physician",
    // },
    // {
    //   id: "dietitianControls",
    //   icon: (
    //     <FaAppleAlt className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
    //   ),
    //   text: "Dietitian Controls",
    //   route: "/dietitian-admin",
    //   moduleKey: "dietition",
    // },
    {
      id: "advertisementControls",
      icon: (
        <AiFillBulb className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
      ),
      text: "Advertisement Controls",
      route: "/advertisement-admin",
      moduleKey: "advertisement",
    },
    // {
    //   id: "ecommerceStore",
    //   icon: (
    //     <FaStore className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
    //   ),
    //   text: "Ecommerce Store",
    //   route: "/ecommerce-admin",
    //   moduleKey: "ecommerce",
    // },
    {
      id: "informaticaControls",
      icon: (
        <FaDatabase className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
      ),
      text: "Informatica Controls",
      route: "/admin",
      moduleKey: "informatica",
    },
    {
      id: "instituteControls",
      icon: (
        <FaUniversity className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
      ),
      text: "Institute Controls",
      route: "/institute-admin",
      moduleKey: "institute",
    },
    {
      id: "sportsControl",
      icon: (
        <FaGamepad className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
      ),
      text: "Sports Control",
      route: "/sports-control",
      moduleKey: "sports_control",
      superAdminOnly: true, // Only accessible by SuperAdmin
    },
  ];

  // Define news sub-modules
  const newsSubModules = [
    {
      id: "rssNews",
      icon: (
        <FaNewspaper className="text-[#4a90e2] mb-[0.8rem] text-[3rem] max-[768px]:text-[2.5rem] max-[480px]:text-[2rem]" />
      ),
      text: "RSS News",
      route: "/News-Home",
      moduleKey: "rss_news",
      superAdminOnly: false,
    },
    {
      id: "newsWriting",
      icon: (
        <FaEdit className="text-[#4a90e2] mb-[0.8rem] text-[3rem] max-[768px]:text-[2.5rem] max-[480px]:text-[2rem]" />
      ),
      text: "News Writing",
      route: "/news-writing",
      moduleKey: "news_writing",
      superAdminOnly: false,
    },
    {
      id: "newsPublishing",
      icon: (
        <FaBullhorn className="text-[#4a90e2] mb-[0.8rem] text-[3rem] max-[768px]:text-[2.5rem] max-[480px]:text-[2rem]" />
      ),
      text: "News Publishing",
      route: "/news-publishing",
      moduleKey: "news_publishing",
      superAdminOnly: false,
    },
  ];

  // Check if admin is superadmin (show all modules)
  const isSuperAdmin = user?.adminRole === "SuperAdmin";

  // Filter modules based on access rights
  const accessibleModules = adminModules.filter((module) => {
    return isSuperAdmin || accessRights[module.moduleKey];
  });

  // Check if any news sub-modules are accessible
  const hasNewsAccess = newsSubModules.some((subModule) => {
    if (subModule.superAdminOnly) {
      return isSuperAdmin;
    }
    return isSuperAdmin || accessRights[subModule.moduleKey];
  });

  // Filter accessible news sub-modules
  const accessibleNewsSubModules = newsSubModules.filter((subModule) => {
    if (subModule.superAdminOnly) {
      return isSuperAdmin;
    }
    return isSuperAdmin || accessRights[subModule.moduleKey];
  });

  const openNewsModal = () => {
    setShowNewsModal(true);
  };

  const closeNewsModal = () => {
    setShowNewsModal(false);
  };

  const handleNewsNavigation = (route) => {
    setShowNewsModal(false);
    navigate(route);
  };

  // Handle logout
  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col items-center p-8 min-h-screen bg-[#f0f2f5]">
      <div className="flex justify-between items-center w-full max-w-[1200px] mb-8 px-4 max-[768px]:flex-col max-[768px]:gap-4 max-[768px]:text-center">
        <h1 className="text-[2rem] md:text-[2.5rem] m-0 text-[#333] max-[480px]:text-[1.5rem]">
          Admin Dashboard
        </h1>
        <button
          className="flex items-center gap-2 py-[0.8rem] px-[1.5rem] bg-[#e74c3c] text-white rounded-[8px] text-[1rem] font-semibold cursor-pointer transition-all duration-300 ease shadow-[0_2px_4px_rgba(0,0,0,0.1)] hover:bg-[#c0392b] hover:-translate-y-[2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.15)] max-[768px]:py-[0.7rem] max-[768px]:px-[1.2rem] max-[768px]:text-[0.9rem] max-[480px]:py-[0.6rem] max-[480px]:px-[1rem] max-[480px]:text-[0.8rem]"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="text-[1rem] m-0 text-white" />
          <span className="text-white m-0">Logout</span>
        </button>
      </div>
      <div className="flex flex-wrap justify-center gap-8">
        {accessibleModules.length > 0 || hasNewsAccess ? (
          <>
            {accessibleModules.map((module) => (
              <button
                key={module.id}
                className="flex flex-col items-center justify-center w-[200px] h-[200px] rounded-[10px] bg-white shadow-[0_4px_6px_rgba(0,0,0,0.1)] transition-all duration-300 ease cursor-pointer hover:-translate-y-[5px] hover:shadow-[0_6px_8px_rgba(0,0,0,0.15)] max-[768px]:w-[150px] max-[768px]:h-[150px] max-[480px]:w-[120px] max-[480px]:h-[120px]"
                onClick={() => navigate(module.route)}
              >
                {module.icon}
                <span className="text-[1.2rem] font-bold text-[#333] max-[768px]:text-[1rem] max-[480px]:text-[0.9rem]">
                  {module.text}
                </span>
              </button>
            ))}

            {/* News Control button that opens modal */}
            {hasNewsAccess && (
              <button
                className="flex flex-col items-center justify-center w-[200px] h-[200px] rounded-[10px] bg-white shadow-[0_4px_6px_rgba(0,0,0,0.1)] transition-all duration-300 ease cursor-pointer hover:-translate-y-[5px] hover:shadow-[0_6px_8px_rgba(0,0,0,0.15)] max-[768px]:w-[150px] max-[768px]:h-[150px] max-[480px]:w-[120px] max-[480px]:h-[120px]"
                onClick={openNewsModal}
              >
                <FaNewspaper className="text-[#4a90e2] mb-4 text-[4rem] max-[768px]:text-[3rem] max-[480px]:text-[2.5rem]" />
                <span className="text-[1.2rem] font-bold text-[#333] max-[768px]:text-[1rem] max-[480px]:text-[0.9rem]">
                  News Control
                </span>
              </button>
            )}
          </>
        ) : (
          <div className="flex flex-col items-center justify-center text-center p-12 mt-8 bg-white rounded-[10px] shadow-[0_4px_6px_rgba(0,0,0,0.1)] max-w-[500px] max-[768px]:p-8 max-[768px]:mt-4">
            <h2 className="text-[1.8rem] text-[#e74c3c] mb-4 font-bold max-[768px]:text-[1.5rem] max-[480px]:text-[1.3rem]">
              No Access Granted
            </h2>
            <p className="text-[1.1rem] text-[#666] leading-[1.5] m-0 max-[768px]:text-[1rem] max-[480px]:text-[0.9rem]">
              You don't have access to any modules. Please contact your
              administrator to request access.
            </p>
          </div>
        )}
      </div>

      {/* News Control Modal */}
      {showNewsModal && (
        <div
          className="fixed inset-0 bg-[rgba(0,0,0,0.5)] flex justify-center items-center z-[1000]"
          onClick={closeNewsModal}
        >
          <div
            className="bg-white rounded-[15px] shadow-[0_10px_30px_rgba(0,0,0,0.3)] max-w-[600px] w-[90%] max-h-[80vh] overflow-hidden max-[768px]:w-[95%] max-[768px]:max-w-[500px] max-[480px]:w-[98%] max-[480px]:m-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center py-6 px-8 border-b border-[#e0e0e0] bg-[#f8f9fa] max-[768px]:py-4 max-[768px]:px-6 max-[480px]:p-4">
              <h2 className="text-[1.5rem] font-semibold text-[#333] m-0 max-[768px]:text-[1.3rem] max-[480px]:text-[1.2rem]">
                News Control
              </h2>
              <button
                className="bg-transparent border-0 text-[1.5rem] text-[#666] cursor-pointer p-2 rounded-full transition-all duration-200 ease flex items-center justify-center hover:bg-[#e9ecef] hover:text-[#333]"
                onClick={closeNewsModal}
              >
                <FaTimes />
              </button>
            </div>
            <div className="p-8 max-[768px]:p-6 max-[480px]:p-4">
              <div className="flex flex-wrap gap-6 justify-center">
                {accessibleNewsSubModules.map((subModule) => (
                  <button
                    key={subModule.id}
                    className="flex flex-col items-center justify-center w-[150px] h-[150px] rounded-[10px] bg-white shadow-[0_4px_8px_rgba(0,0,0,0.1)] transition-all duration-300 ease cursor-pointer border-2 border-[#e9ecef] hover:-translate-y-[3px] hover:shadow-[0_6px_12px_rgba(0,0,0,0.15)] hover:border-[#4a90e2] max-[768px]:w-[120px] max-[768px]:h-[120px] max-[480px]:w-[100px] max-[480px]:h-[100px]"
                    onClick={() => handleNewsNavigation(subModule.route)}
                  >
                    {subModule.icon}
                    <span className="text-[1rem] font-semibold text-[#333] text-center max-[768px]:text-[0.9rem] max-[480px]:text-[0.8rem]">
                      {subModule.text}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DsportAdminDashboard;
